export const WorkerContent: Record<string, string> = {"logWorker": `"use strict";

(() => {
  var f = ["a-im", "accept", "accept-charset", "accept-datetime", "accept-encoding", "accept-language", "access-control-request-method", "cache-control", "connection", "content-encoding", "content-type", "date", "expect", "host", "if-modified-since", "if-unmodified-since", "max-forwards", "origin", "pragma", "prefer", "range", "referer", "te", "trailer", "transfer-encoding", "user-agent", "upgrade", "via", "warning", "upgrade-insecure-requests", "x-requested-with", "dnt", "x-forwarded-host", "x-forwarded-proto", "front-end-https", "x-http-method-override", "proxy-connection", "save-data", "sec-gpc", "accept-ch", "access-control-allow-credentials", "access-control-expose-headers", "access-control-max-age", "access-control-allow-methods", "access-control-allow-headers", "access-control-allow-origin", "accept-patch", "accept-ranges", "age", "allow", "alt-svc", "cache-control", "connection", "content-disposition", "content-encoding", "content-language", "content-length", "content-location", "content-range", "content-type", "date", "delta-base", "expires", "im", "last-modified", "link", "location", "pragma", "preference-applied", "proxy-authenticate", "public-key-pins", "retry-after", "server", "strict-transport-security", "trailer", "transfer-encoding", "tk", "upgrade", "vary", "via", "warning", "www-authenticate", "x-frame-options", "x-content-security-policy", "x-webkit-csp", "content-security-policy", "expect-ct", "nel", "permissions-policy", "refresh", "report-to", "status", "timing-allow-origin", "x-content-duration", "x-content-type-options", "x-powered-by", "x-redirect-by", "x-request-id", "x-correlation-id", "x-ua-compatible", "x-xss-protection", "content-length", "forwarded"],
    d = [],
    p = e => {
      let r = e + "";
      for (let t of d) {
        let n = e.match(t);
        if (n) for (let a of n) r = r.replace(a, "*".repeat(a.length));
      }
      return r;
    },
    u = e => {
      try {
        return JSON.parse(e);
      } catch (r) {
        return e;
      }
    };
  function h(e) {
    var r = [],
      t = [],
      n = new Set(),
      a = !1;
    function o(s, g) {
      if (!(s && typeof s != "object")) {
        if (n.has(s)) {
          a = !0;
          return;
        }
        r.push(g), t.push(s), n.add(s);
        for (var i in s) Object.prototype.hasOwnProperty.call(s, i) && o(s[i], i);
        r.pop(), t.pop(), n.delete(s);
      }
    }
    return o(e, "__45__circ__initial__"), a;
  }
  var y = ["string", "number", "boolean", "undefined", "symbol", "bigint", "null"],
    m = ["headers", "method", "baseurl", "contentlength", "maxcontentlength", "xsrdcookiename", "cookies", "url"],
    l = e => {
      let r = {};
      for (let [t, n] of Object.entries(e)) f.includes(t.toLowerCase()) ? r[t] = p(n) : r[t] = "recapt_log_obfuscated";
      return r;
    },
    c = (e, r = !1) => {
      try {
        if (e === null) return "null";
        if (e === void 0) return "undefined";
        if (y.includes(typeof e)) return p(e.toString());
        if (Array.isArray(e)) return r ? e.map(o => c(o, !0)) : JSON.stringify(e.map(o => c(o, !0)));
        let t = {};
        if (h(e)) return "recapt_log_circular";
        let n = !1,
          a = !1;
        for (let o of Object.keys(e)) if (o.toLowerCase() === "headers" && (a = !0), m.includes(o.toLowerCase()) && (n = !0), a && n) break;
        a ? e.headers = l(e.headers) : n && (e = l(e));
        for (let [o, s] of Object.entries(e)) t[o] = c(s, !0);
        return r ? t : JSON.stringify(t);
      } catch (t) {
        return "recapt_log_unparsable";
      }
    };
  onmessage = e => {
    let {
      id: r,
      payload: t
    } = e.data;
    if (r === "log") {
      if (d.length === 0) return;
      let n = t.messages.map(a => {
        let o = u(a);
        return c(o);
      });
      postMessage({
        id: "log:parsed",
        payload: {
          messages: n,
          timestamp: t.timestamp,
          where: t.where,
          kind: t.kind
        }
      });
    } else r === "regexes:load" && (d = t.map(n => new RegExp(n, "ig")));
  };
  postMessage({
    id: "_self",
    payload: "active"
  });
})();`,
"recordWorker": `"use strict";

(() => {
  var fe = Object.create;
  var K = Object.defineProperty,
    ce = Object.defineProperties,
    ae = Object.getOwnPropertyDescriptor,
    ue = Object.getOwnPropertyDescriptors,
    le = Object.getOwnPropertyNames,
    W = Object.getOwnPropertySymbols,
    de = Object.getPrototypeOf,
    I = Object.prototype.hasOwnProperty,
    pe = Object.prototype.propertyIsEnumerable;
  var $ = (e, n, t) => n in e ? K(e, n, {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: t
    }) : e[n] = t,
    C = (e, n) => {
      for (var t in n || (n = {})) I.call(n, t) && $(e, t, n[t]);
      if (W) for (var t of W(n)) pe.call(n, t) && $(e, t, n[t]);
      return e;
    },
    B = (e, n) => ce(e, ue(n));
  var J = (e, n) => () => (n || e((n = {
    exports: {}
  }).exports, n), n.exports);
  var he = (e, n, t, d) => {
    if (n && typeof n == "object" || typeof n == "function") for (let p of le(n)) !I.call(e, p) && p !== t && K(e, p, {
      get: () => n[p],
      enumerable: !(d = ae(n, p)) || d.enumerable
    });
    return e;
  };
  var me = (e, n, t) => (t = e != null ? fe(de(e)) : {}, he(n || !e || !e.__esModule ? K(t, "default", {
    value: e,
    enumerable: !0
  }) : t, e));
  var U = (e, n, t) => new Promise((d, p) => {
    var l = s => {
        try {
          i(t.next(s));
        } catch (r) {
          p(r);
        }
      },
      o = s => {
        try {
          i(t.throw(s));
        } catch (r) {
          p(r);
        }
      },
      i = s => s.done ? d(s.value) : Promise.resolve(s.value).then(l, o);
    i((t = t.apply(e, n)).next());
  });
  var Q = J(R => {
    "use strict";

    Object.defineProperty(R, "__esModule", {
      value: !0
    });
    R.uncompressJSON = R.compressJSON = void 0;
    var ge = e => {
      let n = {},
        t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
        d = 0,
        p = 1,
        l = {},
        o = new WeakSet(),
        i = h => {
          if (h in n) return n[h];
          let v = "",
            g = d;
          for (let y = 0; y < p; y++) {
            let O = g % t.length;
            v = t[O] + v, g = Math.floor(g / t.length);
          }
          d++;
          let S = Math.pow(t.length, p);
          d >= S && (d = 0, p++);
          let u = "\xA3".concat(v, "\xA3");
          return n[h] = u, u;
        },
        s = h => {
          if (o.has(h)) return h;
          o.add(h);
          let v = [];
          for (let g of h) {
            if (g == null) {
              v.push(g);
              continue;
            }
            if (typeof g != "object") {
              v.push(g);
              continue;
            }
            if (Array.isArray(g)) {
              v.push(s(g));
              continue;
            }
            v.push(r(g));
          }
          return o.delete(h), v;
        },
        r = h => {
          if (o.has(h)) return h;
          o.add(h);
          let v = {};
          for (let g in h) {
            if (!h.hasOwnProperty(g)) continue;
            let S = i(g),
              u = h[g];
            if (u == null) {
              v[S] = u;
              continue;
            }
            if (typeof u != "object") {
              v[S] = u;
              continue;
            }
            Array.isArray(u) ? v[S] = s(u) : v[S] = r(u);
          }
          return o.delete(h), v;
        };
      l = r(e);
      let a = {};
      for (let h in n) a[n[h]] = h;
      return [l, a];
    };
    R.compressJSON = ge;
    var G = (e, n) => {
        let t = [];
        for (let d of e) {
          if (typeof d != "object") {
            t.push(d);
            continue;
          }
          if (Array.isArray(d)) {
            t.push(G(d, n));
            continue;
          }
          t.push(H(d, n));
        }
        return t;
      },
      H = (e, n) => {
        let t = {};
        for (let d in e) {
          let p = n(d);
          if (typeof e[d] != "object") {
            t[p] = e[d];
            continue;
          }
          Array.isArray(e[d]) ? t[p] = G(e[d], n) : t[p] = H(e[d], n);
        }
        return t;
      },
      xe = (e, n) => H(e, p => n[p]);
    R.uncompressJSON = xe;
  });
  var X = J((Te, D) => {
    var L = function () {
      var e = String.fromCharCode,
        n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
        t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$",
        d = {};
      function p(o, i) {
        if (!d[o]) {
          d[o] = {};
          for (var s = 0; s < o.length; s++) d[o][o.charAt(s)] = s;
        }
        return d[o][i];
      }
      var l = {
        compressToBase64: function (o) {
          if (o == null) return "";
          var i = l._compress(o, 6, function (s) {
            return n.charAt(s);
          });
          switch (i.length % 4) {
            default:
            case 0:
              return i;
            case 1:
              return i + "===";
            case 2:
              return i + "==";
            case 3:
              return i + "=";
          }
        },
        decompressFromBase64: function (o) {
          return o == null ? "" : o == "" ? null : l._decompress(o.length, 32, function (i) {
            return p(n, o.charAt(i));
          });
        },
        compressToUTF16: function (o) {
          return o == null ? "" : l._compress(o, 15, function (i) {
            return e(i + 32);
          }) + " ";
        },
        decompressFromUTF16: function (o) {
          return o == null ? "" : o == "" ? null : l._decompress(o.length, 16384, function (i) {
            return o.charCodeAt(i) - 32;
          });
        },
        compressToUint8Array: function (o) {
          for (var i = l.compress(o), s = new Uint8Array(i.length * 2), r = 0, a = i.length; r < a; r++) {
            var h = i.charCodeAt(r);
            s[r * 2] = h >>> 8, s[r * 2 + 1] = h % 256;
          }
          return s;
        },
        decompressFromUint8Array: function (o) {
          if (o == null) return l.decompress(o);
          for (var i = new Array(o.length / 2), s = 0, r = i.length; s < r; s++) i[s] = o[s * 2] * 256 + o[s * 2 + 1];
          var a = [];
          return i.forEach(function (h) {
            a.push(e(h));
          }), l.decompress(a.join(""));
        },
        compressToEncodedURIComponent: function (o) {
          return o == null ? "" : l._compress(o, 6, function (i) {
            return t.charAt(i);
          });
        },
        decompressFromEncodedURIComponent: function (o) {
          return o == null ? "" : o == "" ? null : (o = o.replace(/ /g, "+"), l._decompress(o.length, 32, function (i) {
            return p(t, o.charAt(i));
          }));
        },
        compress: function (o) {
          return l._compress(o, 16, function (i) {
            return e(i);
          });
        },
        _compress: function (o, i, s) {
          if (o == null) return "";
          var r,
            a,
            h = {},
            v = {},
            g = "",
            S = "",
            u = "",
            y = 2,
            O = 3,
            x = 2,
            w = [],
            f = 0,
            c = 0,
            _;
          for (_ = 0; _ < o.length; _ += 1) if (g = o.charAt(_), Object.prototype.hasOwnProperty.call(h, g) || (h[g] = O++, v[g] = !0), S = u + g, Object.prototype.hasOwnProperty.call(h, S)) u = S;else {
            if (Object.prototype.hasOwnProperty.call(v, u)) {
              if (u.charCodeAt(0) < 256) {
                for (r = 0; r < x; r++) f = f << 1, c == i - 1 ? (c = 0, w.push(s(f)), f = 0) : c++;
                for (a = u.charCodeAt(0), r = 0; r < 8; r++) f = f << 1 | a & 1, c == i - 1 ? (c = 0, w.push(s(f)), f = 0) : c++, a = a >> 1;
              } else {
                for (a = 1, r = 0; r < x; r++) f = f << 1 | a, c == i - 1 ? (c = 0, w.push(s(f)), f = 0) : c++, a = 0;
                for (a = u.charCodeAt(0), r = 0; r < 16; r++) f = f << 1 | a & 1, c == i - 1 ? (c = 0, w.push(s(f)), f = 0) : c++, a = a >> 1;
              }
              y--, y == 0 && (y = Math.pow(2, x), x++), delete v[u];
            } else for (a = h[u], r = 0; r < x; r++) f = f << 1 | a & 1, c == i - 1 ? (c = 0, w.push(s(f)), f = 0) : c++, a = a >> 1;
            y--, y == 0 && (y = Math.pow(2, x), x++), h[S] = O++, u = String(g);
          }
          if (u !== "") {
            if (Object.prototype.hasOwnProperty.call(v, u)) {
              if (u.charCodeAt(0) < 256) {
                for (r = 0; r < x; r++) f = f << 1, c == i - 1 ? (c = 0, w.push(s(f)), f = 0) : c++;
                for (a = u.charCodeAt(0), r = 0; r < 8; r++) f = f << 1 | a & 1, c == i - 1 ? (c = 0, w.push(s(f)), f = 0) : c++, a = a >> 1;
              } else {
                for (a = 1, r = 0; r < x; r++) f = f << 1 | a, c == i - 1 ? (c = 0, w.push(s(f)), f = 0) : c++, a = 0;
                for (a = u.charCodeAt(0), r = 0; r < 16; r++) f = f << 1 | a & 1, c == i - 1 ? (c = 0, w.push(s(f)), f = 0) : c++, a = a >> 1;
              }
              y--, y == 0 && (y = Math.pow(2, x), x++), delete v[u];
            } else for (a = h[u], r = 0; r < x; r++) f = f << 1 | a & 1, c == i - 1 ? (c = 0, w.push(s(f)), f = 0) : c++, a = a >> 1;
            y--, y == 0 && (y = Math.pow(2, x), x++);
          }
          for (a = 2, r = 0; r < x; r++) f = f << 1 | a & 1, c == i - 1 ? (c = 0, w.push(s(f)), f = 0) : c++, a = a >> 1;
          for (;;) if (f = f << 1, c == i - 1) {
            w.push(s(f));
            break;
          } else c++;
          return w.join("");
        },
        decompress: function (o) {
          return o == null ? "" : o == "" ? null : l._decompress(o.length, 32768, function (i) {
            return o.charCodeAt(i);
          });
        },
        _decompress: function (o, i, s) {
          var r = [],
            a,
            h = 4,
            v = 4,
            g = 3,
            S = "",
            u = [],
            y,
            O,
            x,
            w,
            f,
            c,
            _,
            m = {
              val: s(0),
              position: i,
              index: 1
            };
          for (y = 0; y < 3; y += 1) r[y] = y;
          for (x = 0, f = Math.pow(2, 2), c = 1; c != f;) w = m.val & m.position, m.position >>= 1, m.position == 0 && (m.position = i, m.val = s(m.index++)), x |= (w > 0 ? 1 : 0) * c, c <<= 1;
          switch (a = x) {
            case 0:
              for (x = 0, f = Math.pow(2, 8), c = 1; c != f;) w = m.val & m.position, m.position >>= 1, m.position == 0 && (m.position = i, m.val = s(m.index++)), x |= (w > 0 ? 1 : 0) * c, c <<= 1;
              _ = e(x);
              break;
            case 1:
              for (x = 0, f = Math.pow(2, 16), c = 1; c != f;) w = m.val & m.position, m.position >>= 1, m.position == 0 && (m.position = i, m.val = s(m.index++)), x |= (w > 0 ? 1 : 0) * c, c <<= 1;
              _ = e(x);
              break;
            case 2:
              return "";
          }
          for (r[3] = _, O = _, u.push(_);;) {
            if (m.index > o) return "";
            for (x = 0, f = Math.pow(2, g), c = 1; c != f;) w = m.val & m.position, m.position >>= 1, m.position == 0 && (m.position = i, m.val = s(m.index++)), x |= (w > 0 ? 1 : 0) * c, c <<= 1;
            switch (_ = x) {
              case 0:
                for (x = 0, f = Math.pow(2, 8), c = 1; c != f;) w = m.val & m.position, m.position >>= 1, m.position == 0 && (m.position = i, m.val = s(m.index++)), x |= (w > 0 ? 1 : 0) * c, c <<= 1;
                r[v++] = e(x), _ = v - 1, h--;
                break;
              case 1:
                for (x = 0, f = Math.pow(2, 16), c = 1; c != f;) w = m.val & m.position, m.position >>= 1, m.position == 0 && (m.position = i, m.val = s(m.index++)), x |= (w > 0 ? 1 : 0) * c, c <<= 1;
                r[v++] = e(x), _ = v - 1, h--;
                break;
              case 2:
                return u.join("");
            }
            if (h == 0 && (h = Math.pow(2, g), g++), r[_]) S = r[_];else if (_ === v) S = O + O.charAt(0);else return null;
            u.push(S), r[v++] = O + S.charAt(0), h--, O = S, h == 0 && (h = Math.pow(2, g), g++);
          }
        }
      };
      return l;
    }();
    typeof define == "function" && define.amd ? define(function () {
      return L;
    }) : typeof D != "undefined" && D != null ? D.exports = L : typeof angular != "undefined" && angular != null && angular.module("LZString", []).factory("LZString", function () {
      return L;
    });
  });
  var ee = J(b => {
    "use strict";

    var ye = b && b.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(b, "__esModule", {
      value: !0
    });
    b.uncompressString = b.asyncCompressString = b.shouldCompressStringAsync = b.compressString = void 0;
    var N = ye(X()),
      V = 500 * 1024,
      Y = 400 * 1024,
      Z = "\xA7CHUNKED\xA7",
      ve = () => new Promise(e => {
        setTimeout(e, 0);
      }),
      we = e => e == null ? "" : N.default.compressToBase64(e);
    b.compressString = we;
    var Se = e => !(e == null || e.length <= V);
    b.shouldCompressStringAsync = Se;
    var _e = e => U(b, null, function* () {
      if (e == null) return "";
      if (e.length <= V) return N.default.compressToBase64(e);
      let n = [],
        t = 0;
      for (; t < e.length;) {
        let d = e.substring(t, t + Y),
          p = N.default.compressToBase64(d);
        n.push(p), t += Y, t < e.length && (yield ve());
      }
      return "".concat(Z).concat(n.length, ":").concat(n.join("|"));
    });
    b.asyncCompressString = _e;
    var be = e => {
      if (e == null) return "";
      if (e.startsWith(Z)) {
        let n = e.substring(Z.length),
          t = n.indexOf(":");
        if (t === -1) return N.default.decompressFromBase64(e) || "";
        let d = parseInt(n.substring(0, t), 10),
          l = n.substring(t + 1).split("|");
        if (l.length !== d) return N.default.decompressFromBase64(e) || "";
        let o = [];
        for (let i of l) {
          let s = N.default.decompressFromBase64(i);
          if (s === null) return "";
          o.push(s);
        }
        return o.join("");
      }
      return N.default.decompressFromBase64(e) || "";
    };
    b.uncompressString = be;
  });
  var ne = J((De, z) => {
    (function () {
      let e = this,
        n = l => new TextEncoder().encode(l);
      function t(l, o) {
        typeof l == "string" && (l = n(l));
        let i = l.length,
          s = o ^ i,
          r = 0,
          a;
        for (; i >= 4;) a = l[r] & 255 | (l[++r] & 255) << 8 | (l[++r] & 255) << 16 | (l[++r] & 255) << 24, a = (a & 65535) * 1540483477 + (((a >>> 16) * 1540483477 & 65535) << 16), a ^= a >>> 24, a = (a & 65535) * 1540483477 + (((a >>> 16) * 1540483477 & 65535) << 16), s = (s & 65535) * 1540483477 + (((s >>> 16) * 1540483477 & 65535) << 16) ^ a, i -= 4, ++r;
        switch (i) {
          case 3:
            s ^= (l[r + 2] & 255) << 16;
          case 2:
            s ^= (l[r + 1] & 255) << 8;
          case 1:
            s ^= l[r] & 255, s = (s & 65535) * 1540483477 + (((s >>> 16) * 1540483477 & 65535) << 16);
        }
        return s ^= s >>> 13, s = (s & 65535) * 1540483477 + (((s >>> 16) * 1540483477 & 65535) << 16), s ^= s >>> 15, s >>> 0;
      }
      function d(l, o) {
        typeof l == "string" && (l = n(l));
        let i, s, r, a, h, v, g, S, u, y;
        for (i = l.length & 3, s = l.length - i, r = o, h = 3432918353, g = 461845907, y = 0; y < s;) u = l[y] & 255 | (l[++y] & 255) << 8 | (l[++y] & 255) << 16 | (l[++y] & 255) << 24, ++y, u = (u & 65535) * h + (((u >>> 16) * h & 65535) << 16) & 4294967295, u = u << 15 | u >>> 17, u = (u & 65535) * g + (((u >>> 16) * g & 65535) << 16) & 4294967295, r ^= u, r = r << 13 | r >>> 19, a = (r & 65535) * 5 + (((r >>> 16) * 5 & 65535) << 16) & 4294967295, r = (a & 65535) + 27492 + (((a >>> 16) + 58964 & 65535) << 16);
        switch (u = 0, i) {
          case 3:
            u ^= (l[y + 2] & 255) << 16;
          case 2:
            u ^= (l[y + 1] & 255) << 8;
          case 1:
            u ^= l[y] & 255, u = (u & 65535) * h + (((u >>> 16) * h & 65535) << 16) & 4294967295, u = u << 15 | u >>> 17, u = (u & 65535) * g + (((u >>> 16) * g & 65535) << 16) & 4294967295, r ^= u;
        }
        return r ^= l.length, r ^= r >>> 16, r = (r & 65535) * 2246822507 + (((r >>> 16) * 2246822507 & 65535) << 16) & 4294967295, r ^= r >>> 13, r = (r & 65535) * 3266489909 + (((r >>> 16) * 3266489909 & 65535) << 16) & 4294967295, r ^= r >>> 16, r >>> 0;
      }
      let p = d;
      if (p.v2 = t, p.v3 = d, typeof z != "undefined") z.exports = p;else {
        let l = e.murmur;
        p.noConflict = function () {
          return e.murmur = l, p;
        }, e.murmur = p;
      }
    })();
  });
  var te = J(j => {
    "use strict";

    var Ae = j && j.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };
    Object.defineProperty(j, "__esModule", {
      value: !0
    });
    j.hashString = void 0;
    var Oe = Ae(ne()),
      Me = e => Oe.default.v3(e);
    j.hashString = Me;
  });
  var re = J(M => {
    "use strict";

    var Ne = M && M.__createBinding || (Object.create ? function (e, n, t, d) {
        d === void 0 && (d = t);
        var p = Object.getOwnPropertyDescriptor(n, t);
        (!p || ("get" in p ? !n.__esModule : p.writable || p.configurable)) && (p = {
          enumerable: !0,
          get: function () {
            return n[t];
          }
        }), Object.defineProperty(e, d, p);
      } : function (e, n, t, d) {
        d === void 0 && (d = t), e[d] = n[t];
      }),
      F = M && M.__exportStar || function (e, n) {
        for (var t in e) t !== "default" && !Object.prototype.hasOwnProperty.call(n, t) && Ne(n, e, t);
      };
    Object.defineProperty(M, "__esModule", {
      value: !0
    });
    F(Q(), M);
    F(ee(), M);
    F(te(), M);
  });
  var A = me(re(), 1);
  var q = {},
    se = [],
    k = !1,
    oe = e => {
      let n = e + "";
      for (let t of se) {
        let d = e.match(t);
        if (d) for (let p of d) n = n.replace(p, "*".repeat(p.length));
      }
      return n;
    },
    E = [],
    Ce = e => {
      if (e.attributes) {
        if (e.attributes._cssText) return;
        if (e.attributes._requestCssId) {
          let n = e.attributes._requestCssId;
          if (E.includes(n)) return;
          E.push(n);
        }
      }
    },
    Je = e => !("textContent" in e) || !e.textContent ? e : B(C({}, e), {
      textContent: oe(e.textContent)
    }),
    P = e => {
      let n = Je(e);
      return Ce(n), "childNodes" in n ? B(C({}, n), {
        childNodes: n.childNodes.map(P)
      }) : n;
    },
    T = [],
    Re = () => U(null, null, function* () {
      for (; T.length > 0;) {
        let e = T.shift();
        if (e) try {
          let n = yield (0, A.asyncCompressString)(e.stringifiedCompressedJSON);
          ie({
            keyMapping: e.keyMapping,
            isStartEvent: e.isStartEvent,
            timestamp: e.timestamp,
            where: e.where,
            compressed: n
          });
        } catch (n) {
          k && console.log("compression job failed", n);
        }
      }
    }),
    je = ({
      keyMapping: e,
      isStartEvent: n,
      timestamp: t,
      where: d,
      stringifiedCompressedJSON: p
    }) => {
      if (T.length > 5) {
        k && console.log("compression job queue is full, dropping job");
        return;
      }
      T.push({
        keyMapping: e,
        isStartEvent: n,
        timestamp: t,
        where: d,
        stringifiedCompressedJSON: p
      }), T.length === 1 && (k && console.log("starting compression jobs"), Re());
    },
    ie = ({
      keyMapping: e,
      isStartEvent: n,
      timestamp: t,
      where: d,
      compressed: p
    }) => {
      let l = (0, A.hashString)(JSON.stringify(e));
      l in q || (q[l] = (0, A.compressString)(JSON.stringify(e)), postMessage({
        id: "keymapping:added",
        payload: q
      }));
      let o = {
        keyMappingLookup: l,
        compressed: p,
        timestamp: t,
        where: d
      };
      n && (o.isStartEvent = !0), postMessage({
        id: "event:parsed",
        payload: o
      });
    };
  onmessage = e => {
    try {
      let {
        id: n,
        payload: t
      } = e.data;
      if (n === "event") {
        let d = "type" in t.event && t.event.type === 4;
        if ("data" in t.event && ("texts" in t.event.data && (t.event.data.texts = t.event.data.texts.map(s => C({
          value: oe(s.value)
        }, s))), "adds" in t.event.data && (t.event.data.adds = t.event.data.adds.map(s => "node" in s ? B(C({}, s), {
          node: P(s.node)
        }) : s)), "node" in t.event.data && (t.event.data.node = P(t.event.data.node))), E.length > 0 && "canReject" in t && t.canReject === !0) {
          postMessage({
            id: "event:awaiting-resolutions",
            payload: B(C({}, t), {
              requestedResolutions: E
            })
          }), E = [];
          return;
        }
        let [p, l] = (0, A.compressJSON)(t.event),
          o = JSON.stringify(p);
        if ((0, A.shouldCompressStringAsync)(o)) je({
          keyMapping: l,
          isStartEvent: d,
          timestamp: t.event.timestamp,
          where: t.event.where,
          stringifiedCompressedJSON: o
        });else {
          let s = (0, A.compressString)(o);
          ie({
            keyMapping: l,
            isStartEvent: d,
            timestamp: t.event.timestamp,
            where: t.event.where,
            compressed: s
          });
        }
      } else n === "regexes:load" ? se = t.map(d => new RegExp(d, "ig")) : n === "purge-state" ? q = {} : n === "debug-mode" && (k = !0);
    } catch (n) {
      k && console.log("record worker got error", n);
    }
  };
  postMessage({
    id: "_self",
    payload: "active"
  });
})();`,

};